module.exports = __webpack_public_path__ + "static/img/cont40_04.21789be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_04.jpg
// module id = c1Vf
// module chunks = 0